(() => {
  if (customElements.get('custom-featured-collection')) return;

  class CustomFeaturedCollection extends HTMLElement {
    connectedCallback() {
      this.onResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.configure(), 150);
      };
      this.onReady = () => this.configure();
      window.addEventListener('resize', this.onResize);
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
      } else {
        this.configure();
      }
    }

    configure() {
      if (!this.isConnected || !window.Splide) return;
      const root = this.querySelector('.custom-featured__slider');
      if (!root) return;
      const count = root.querySelectorAll('.custom-featured__slide').length;
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const tablet = window.matchMedia('(max-width: 989px)').matches;
      const columns = mobile ? Number(this.dataset.mobile) : Math.min(Number(this.dataset.desktop), tablet ? 2 : 6);
      const enabled = (mobile ? this.dataset.mobileSlider : this.dataset.desktopSlider) === 'true' && count > columns;
      const styles = getComputedStyle(this);
      const peek = parseFloat(styles.getPropertyValue('--cf-active-peek')) || 0;
      const gap = parseFloat(styles.getPropertyValue('--cf-active-gap')) || 16;
      const signature = [columns, enabled, peek, gap].join(':');
      if (signature === this.signature) return;
      const previousIndex = this.slider?.index;
      this.slider?.destroy(true);
      this.slider = null;
      this.signature = signature;
      if (!enabled) return;

      // A finite, rewinding track preserves each product form's unique IDs.
      // Start one card in only when both adjacent previews can actually exist.
      // const start = previousIndex === undefined
      //   ? (peek > 0 && count >= columns + 2 ? 1 : 0)
      //   : Math.min(previousIndex, Math.max(0, count - columns));
      this.slider = new window.Splide(root, {
        type: 'loop',
        perPage: columns,
        perMove: 1,
        // start,
        gap,
        // padding: { left: peek, right: peek },
        // trimSpace: false,
        rewind: this.dataset.rewind === 'true',
        speed: Number(this.dataset.speed) || 500,
        arrows: true,
        pagination: false,
        autoplay: this.dataset.autoplay === 'true' && !window.Shopify?.designMode,
        interval: Number(this.dataset.interval) || 5000,
        pauseOnHover: true,
        pauseOnFocus: true,
        keyboard: false,
        noDrag: 'input, button, select, textarea, .quick-add',
        reducedMotion: { speed: 0, rewindSpeed: 0, autoplay: 'pause' },
      });
      this.slider.mount();
    }

    disconnectedCallback() {
      clearTimeout(this.resizeTimer);
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('DOMContentLoaded', this.onReady);
      this.slider?.destroy(true);
      this.slider = null;
      this.signature = null;
    }
  }

  customElements.define('custom-featured-collection', CustomFeaturedCollection);
})();
